import { render } from "./BotTask.vue?vue&type=template&id=0c27a628&scoped=true"
import script from "./BotTask.vue?vue&type=script&lang=js"
export * from "./BotTask.vue?vue&type=script&lang=js"

import "./BotTask.vue?vue&type=style&index=0&id=0c27a628&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\MonsterView\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c27a628"]])

export default __exports__